export default __webpack_public_path__ + "static/media/apollo_4.2e0d173c.jpg";